module.exports = __webpack_public_path__ + "img/ss.3c9eb1fd.svg";